import React
	// , { useEffect }
from "react";
// import { Counter } from "./features/counter/Counter";
import "./App.css";
import HomeScreen from "./pages/Home/HomeScreen";
import Landing from "./pages/Landing/Landing";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { auth } from "./firebase";
// import { logout, login, selectUser } from "./features/userSlice";
import Profile from "./pages/Profile/Profile";
import Movie from "./pages/Movie/Movie";
import Actor from "./pages/Actor/Actor";

function App() {
	// const user = useSelector(selectUser);
	// const dispatch = useDispatch();

	// useEffect(() => {
	// 	const unsubscribe = auth.onAuthStateChanged((userAuth) => {
	// 		if (userAuth) {
	// 			dispatch(
	// 				login({
	// 					uid: userAuth.uid,
	// 					email: userAuth.email,
	// 					password: userAuth.password,
	// 				})
	// 			);
	// 		} else {
	// 			dispatch(logout());
	// 		}
	// 	});

	// 	return unsubscribe;
	// }, [dispatch]);

	return (
		<div className="app">
			<Router>
				<Routes>
					<Route path="/profile" element={<Profile />}></Route>
					<Route path="/movie/:id" element={<Movie />}></Route>
					<Route path="/actor/:id" element={<Actor />}></Route>
					<Route path="/landing" exact element={<Landing />}></Route>
					<Route path="/" exact element={<HomeScreen />}></Route>
				</Routes>
			</Router>
		</div>
	);
}

export default App;
